<template>
  <div>
    <v-col cols="12">
      <v-alert v-if="informText != ''">
        {{ informText }}
      </v-alert>
      <div>
        <v-row>
          <v-col cols="4">
            <v-select
              :items="listDate"
              outlined
              dense
              label="Date"
              v-model="dateSelected"
              @change="
                chooseDate();
                validation();
              "
            ></v-select>
          </v-col>
          <v-col cols="8">
            <v-text-field
              dense
              outlined
              label="Note"
              v-model="noteData"
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <div>
        <v-btn @click="saveData" color="success" dark small v-if="showBtn"
          >Save</v-btn
        >
        <v-btn small v-else disabled>Save</v-btn>
        &nbsp;
        <v-btn @click="cancelData" color="orange" dark small>Cancel</v-btn>
      </div>
    </v-col>
  </div>
</template>

<script>
import moment from "moment-timezone";
export default {
  name: "DialogEditNote",

  props: {
    obj: Object,
  },

  data: () => ({
    listDate: [],
    noteData: "",
    dateSelected: "",
    informText: "",
    showBtn: true,
  }),

  methods: {
    cancelData() {
      this.$root.$refs.reportFBByDay.turnOffDialog();
    },

    converData() {
      for (const a in this.obj.item) {
        if (
          a != "product_code" &&
          a != "product_title" &&
          a != "product_thumbnail" &&
          a != "short_title" &&
          a != "showName" &&
          a != "avg_roi"
        ) {
          this.listDate.push(a);
        }
      }
      //console.log("listDate: ", this.listDate);
    },

    chooseDate() {
      this.noteData = this.obj.item[this.dateSelected].note;
    },

    async saveData() {
      var year = moment(this.obj.date[0]).format("YYYY");
      var temp = this.dateSelected + "/" + year;
      //console.log(temp);
      var date = moment(temp).format("YYYY/MM/DD");
      //console.log("date: ", date);

      var currentSession = await this.$root.$refs.App.currentSession(
        "PSL-product-add-saveData"
      );
      if (currentSession.accessToken) {
        fetch(window.domain + "marketing/ad-note", {
          method: "POST",
          headers: { Authorization: currentSession.accessToken },
          body: JSON.stringify({
            date: date,
            product_code: this.obj.item.product_code,
            note: this.noteData,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("data response: ", data);
            if (data.error_message == "") {
              this.cancelData();
            } else {
              this.informText = data.error_message;
            }
          });
      }
    },

    validation() {
      if (this.dateSelected != "") {
        this.showBtn = true;
      } else {
        this.showBtn = false;
      }
    },
  },

  mounted() {
    this.converData();
    this.validation();
  },
};
</script>

<style lang="scss" scoped>
</style>